declare namespace $ {

	export class $mol_icon_collapse_all extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=all.view.tree.d.ts.map